// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ij-7";
export var emphasizeQuantity = "_ij-3";
export var flatBottomCorners = "_ij-5";
export var productImage = "_ij-0";
export var quantityContainer = "_ij-2";
export var quantityHeader = "_ij-6";
export var tooltip = "_ij-1";
export var wrapAndEllipsesOverflow = "_ij-4";